import * as React from 'react'
/**
 * Renders an input field component with label.
 *
 * @param {InputFieldProps} InputFieldProps - The component props.
 * @returns {JSX.Element} - The rendered component.
 */
const InputField = ({
  labelText,
  id,
  type,
  name,
  value,
  onChange = () => {},
  onBlur = () => {},
  onFocus = () => {},
  className = '',
  labelClassName = '',
  placeholder = '',
  autoComplete = 'off',
  disabled = false
}) => {
  return (
    <div>
      <label className={`caption ${labelClassName}`} htmlFor={id}>
        {labelText}
      </label>
      <input
        id={id}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        className={className}
        placeholder={placeholder}
        autoComplete={autoComplete}
        disabled={disabled}
      />
    </div>
  )
}

/**
 * @typedef {{
 *  labelText: string,
 * id: string,
 * type: string,
 * name: string,
 * value: string,
 * onChange?: React.ChangeEventHandler<HTMLInputElement>,
 * onBlur?: React.FocusEventHandler<HTMLInputElement>,
 * onFocus?: React.FocusEventHandler<HTMLInputElement>,
 * className?: string,
 * labelClassName?: string,
 * placeholder?: string,
 * autoComplete?: string,
 * disabled?: boolean,
 * }} InputFieldProps
 */

export default InputField
